import * as React from 'react';

import { GeneralOfferPaymentCondition, GeneralOrderPaymentCondition } from '@Graphql/graphqlTypes.generated';
import { useTranslations } from '@Hooks/useTranslations';
import { MessageKeysWithoutParams } from '@Utils/translation';

import SelectInput, { SelectInputProps } from '../SelectInput';

type GeneralOrderPaymentConditionSelectProps = {} & SelectInputProps;

const conditions = {
  [GeneralOrderPaymentCondition.FullPayment]: 'msg_general_order_condition_full_payment',
  [GeneralOrderPaymentCondition.FiftyFiftySplit]: 'msg_general_order_condition_fifty_fifty_split',
  [GeneralOrderPaymentCondition.AfterThirtyDaysWithAdvance]:
    'msg_general_order_condition_after_thirty_days_with_advance',
} satisfies Record<GeneralOfferPaymentCondition, MessageKeysWithoutParams>;

const GeneralOrderPaymentConditionSelect: React.FC<GeneralOrderPaymentConditionSelectProps> = props => {
  const t = useTranslations();

  const options = Object.entries(conditions).map(([value, msgKey]) => ({
    value: value as GeneralOrderPaymentCondition,
    label: t(msgKey),
  }));

  return <SelectInput options={options} {...props} />;
};

export default GeneralOrderPaymentConditionSelect;
